module.exports = __webpack_public_path__ + "media/images/Edge-5f343657.png";